import { useSize } from '@nhl/react-hooks/lib/useSize';

const SCREEN_RESIZE_THROTTLE = 100; // in ms

type Size = { height: number; width: number };

export const useSizeWithThrottle = (throttleTime = SCREEN_RESIZE_THROTTLE): Size => useSize(throttleTime);
